<template>
  <div class='idcardImg'>
    <div class="box-1">
      <div class="cover"  @click="selectFile" v-loading="loading">
        <img :src="require('./images/1.png')" alt="">
      </div>
      <div class="info">
        <el-alert title="请点击左侧图片上传身份证正面照片" type="success" effect="dark" :closable="false"  />
        <div style="height: 15px"></div>
        <div class="card" v-if="idcard">
          <div><span>姓名</span>：{{idcard['姓名'].words}}</div>
          <div style="height: 10px"></div>
          <div><span>性别</span>：{{idcard['性别'].words}}</div>
          <div style="height: 10px"></div>
          <div><span>身份证</span>：{{idcard['公民身份号码'].words}}</div>
        </div>
      </div>
    </div>

    <!-- 表单文件上传 -->
    <input type="file" ref="uploadRef" @change="changeFile" hidden>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus'
import { ref, reactive, toRefs } from "vue"
import { bdsfz } from "@/api"
import { api } from "@/api"
export default {
  name:'idcard',
  setup() {
    let initData = reactive({
      idcard: "",
      loading: false
    })
    let uploadRef = ref(null)
    // 触发文件上传
    function selectFile() {
      uploadRef.value.click()
    }
    // 文件上传
    function changeFile() {
      
      let file = uploadRef.value.files
      // 验证是不是选择了照片
      if(Object.keys(file).length == 0) {
        return
      }
      if(file[0].size > 1024 * 1024 * 10) {
        ElMessage.warning('文件大小限制10M')
        return
      }
      initData.loading = true
      let reader = new FileReader() // 读取文件
      reader.readAsDataURL(file[0])  // 将文件读取为 DataURL
      reader.onloadend = function() { // 读取成功后触发
        if (file[0].size > 1024 * 1024 * 2) {
          let canvas = document.createElement('canvas') // 创建Canvas对象(画布)
          let context = canvas.getContext('2d')
          let img = new Image()
          img.src = this.result // 指定图片的DataURL(图片的base64编码数据)
          img.onload = function() {
            let w = this.width;
            let h = this.height;
            let scale = w / h;
            canvas.width = 500;
            canvas.height = 500 / scale;
            context.drawImage(img, 0, 0, 500, 500 / scale)
            // 在指定图片格式为 image/jpeg 或 image/webp的情况下，可以从 0 到 1 的区间内选择图片的质量。如果超出取值范围，将会使用默认值 0.92。其他参数会被忽略。
            let base64 = canvas.toDataURL(file[0].type, 0.7) // 0.92为默认压缩质量
            postDiscernIdCard(base64)
        
          }
        } else { //小于2M直接上传
          postDiscernIdCard(this.result)
        }
      }
    
    }
    
    // 读取证件信息
    function postDiscernIdCard(base64) {
      initData.idcard = ""
      // 获取百度token
      api("get", "getBaiduAccessToken", {}).then(res => {
        
        if(res.code == 1200) {
          bdsfz(res.data, base64).then(response => {
            initData.loading = false
            if(response.image_status == "normal") {
              initData.idcard = response.words_result
            } else {
              ElMessageBox.alert('信息识别失败！请重新上传', '提示', {
                confirmButtonText: 'OK',
                callback: (action) => {
                  
                },
              })
            }
          })
          .catch(err => {
            initData.loading = false
            console.log(err)
          })
        } else {
          initData.loading = false
          ElMessageBox.alert('授权码获取失败！请刷新页面重新尝试', '提示', {
            confirmButtonText: 'OK',
            callback: (action) => {
              
            },
          })
        }
      })
    }
    
    return {
      ...toRefs(initData),
      selectFile,
      changeFile,
      uploadRef
    }
  }
  
}
</script>
<style lang='less' scoped>
.box-1 {
  display: flex;
  .cover {
    width: 250px;
    // height: 200px;
    font-size: 0;
    border-radius: 4px;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .info {
    padding-left: 20px;
    width: 330px;
    .card {
      width: 330px;
      height: 118px;
      // border: 3px dashed #ddd;
      padding: 15px;
      border-radius: 4px;
      box-sizing: border-box;
      vertical-align: top;
      margin-right: 10px;
      margin-bottom: 10px;
      color: #fff;
      font-size: 15px;
      background-color: #585858;
      span {
        display: inline-block;
        width: 60px;
        text-align: justify;
        text-align-last: justify;
        vertical-align: top;
      }
    }
  }
}
</style>